import Marquee from "react-fast-marquee";

const items = [
  "Empowering stay-at-home moms",
  "AI literacy for grandmothers",
  "Everyday confidence for every mom",
  "Plain language, made for real life",
  "Learning together, woman to woman",
];

export const EditorialMarquee = () => (
  <div className="bg-ember-soft border-y border-linen py-5 overflow-hidden" data-testid="editorial-marquee">
    <Marquee speed={30} gradient={false} pauseOnHover>
      {items.map((item, i) => (
        <span key={i} className="flex items-center">
          <span className="font-cormorant italic text-2xl md:text-3xl text-stone-700 px-6">{item}</span>
          <span className="h-2 w-2 rounded-full bg-ember inline-block" />
        </span>
      ))}
    </Marquee>
  </div>
);
